// ═══ 인보이스 OCR 핸들러 — useInvoiceState.js 에서 분리 (Phase 2 시동, 2026-05-08) ═══
// 분석 보고서: docs/analysis/use-invoice-state-split-2026-05-08.md
//
// applyOcrResult / handleScreenshot / handleTextPaste 를 pure util 로 분리.
// React state setter 들은 deps 객체로 주입 — useState 의존성 명시화.
import { API, authFetch } from './api';

// OCR 응답(이미지/텍스트 공통) → 폼 반영 + 차량 매칭 처리
// deps: { setSsLoading, setSsResult, setContainerNo, setSealNo, setEntryPoint, setBkNo,
//         setVesselName, setToPort, setFromPort, setSelBuyer, setConsignee, setCarRows,
//         buyers, mkRow, showToast }
export function applyOcrResult(d, sourceLabel, deps) {
  deps.setSsLoading(false);
  if (!d.success) { deps.showToast('OCR 실패: ' + (d.error || ''), 'err'); return; }
  deps.setSsResult(d);
  var o = d.ocrData || {};
  if (o.containerNo) deps.setContainerNo(o.containerNo);
  if (o.sealNo) deps.setSealNo(o.sealNo);
  if (o.entryPoint) deps.setEntryPoint(o.entryPoint);
  if (o.bkNo) deps.setBkNo(o.bkNo);
  if (o.vesselName) deps.setVesselName(o.vesselName);
  if (o.toPort) deps.setToPort(o.toPort);
  else if (o.destination) deps.setToPort(o.destination);
  if (o.fromPort) deps.setFromPort(o.fromPort);
  var buyerStr = o.consignee || o.buyerName || '';
  var addrStr = o.buyerAddress || '';
  if (buyerStr) {
    var match = deps.buyers.find(function(b){ return b.name && b.name.toLowerCase().indexOf(buyerStr.toLowerCase()) >= 0; });
    if (match) {
      deps.setSelBuyer(match);
      deps.setConsignee(addrStr ? (match.name + '\n' + addrStr) : match.name);
      if (addrStr && !match.addr) {
        authFetch(API + '/buyers/' + match.id, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(Object.assign({}, match, { addr: addrStr }))
        }).catch(function(){});
      }
    } else { deps.setConsignee(addrStr ? (buyerStr + '\n' + addrStr) : buyerStr); }
  }
  if (d.matchedCars && d.matchedCars.length > 0) {
    var newRows = d.matchedCars.map(function(c){ return deps.mkRow(c); });
    deps.setCarRows(function(prev){
      var existing = prev.filter(function(r){ return r.vin; });
      var combined = existing.concat(newRows.filter(function(nr){
        return !existing.find(function(er){ return er.vin === nr.vin; });
      }));
      return combined.length > 0 ? combined : [deps.mkRow(null)];
    });
  }
  var msg = (sourceLabel || '스크린샷') + ' 분석 완료';
  if (d.matchedCars && d.matchedCars.length > 0) msg += ' (차량 ' + d.matchedCars.length + '대 매칭)';
  if (d.unmatchedVins && d.unmatchedVins.length > 0) msg += ' / 미등록 ' + d.unmatchedVins.length + '대';
  deps.showToast(msg);
}

// 스크린샷 OCR — 이미지 file → /invoices/screenshot-ocr (FormData)
// deps: applyOcrResult deps + { setSsImageUrl, ssImageUrl, onOcrOriginal }
// 분석에 쓴 원본은 저장 시 첨부서류로 자동 등록된다 (#311, 같은 파일 재업로드 제거).
// #364 — 대기(pending) vs 즉시 업로드 분기는 훅(onOcrOriginal)에 위임, util 은 순수 유지.
export function handleScreenshot(file, deps) {
  if (!file) return;
  deps.setSsLoading(true);
  deps.setSsResult(null);
  try { if (deps.ssImageUrl) URL.revokeObjectURL(deps.ssImageUrl); } catch (e) {}
  deps.setSsImageUrl(URL.createObjectURL(file));
  var fd = new FormData();
  fd.append('image', file);
  authFetch(API + '/invoices/screenshot-ocr', { method: 'POST', body: fd })
    .then(function(r){ return r.json(); })
    .then(function(d){
      applyOcrResult(d, '스크린샷', deps);
      // 분석 성공한 원본만 대기/업로드 — 실패분이 첨부로 남지 않게 한다.
      if (d && d.success && deps.onOcrOriginal) {
        deps.onOcrOriginal({ file: file, name: file.name || 'screenshot.jpg' });
      }
    })
    .catch(function(){
      deps.setSsLoading(false);
      deps.showToast('스크린샷 분석 실패', 'err');
    });
}

// 텍스트 붙여넣기 OCR — Clova 생략, 바로 Haiku 구조화
// deps: applyOcrResult deps + { setSsImageUrl, ssImageUrl }
export function handleTextPaste(text, deps) {
  if (!text || !text.trim()) return;
  deps.setSsLoading(true);
  deps.setSsResult(null);
  try { if (deps.ssImageUrl) URL.revokeObjectURL(deps.ssImageUrl); } catch (e) {}
  deps.setSsImageUrl('');
  // 텍스트 OCR 은 원본 파일이 없다 — 직전 스크린샷이 첨부로 남지 않게 비운다 (#364).
  if (deps.setPendingOcrFile) {
    deps.setPendingOcrFile(null);
    if (deps.showToast) deps.showToast('텍스트 입력은 원본 이미지가 없어 쇼링 내역서가 자동 첨부되지 않습니다 — 첨부서류에 이미지를 올려주세요');
  }
  authFetch(API + '/invoices/screenshot-ocr', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ text: text })
  })
    .then(function(r){ return r.json(); })
    .then(function(d){ applyOcrResult(d, '텍스트', deps); })
    .catch(function(){
      deps.setSsLoading(false);
      deps.showToast('텍스트 분석 실패', 'err');
    });
}
